import React, { useEffect, useMemo, useState } from 'react'
import { Login } from './screens/Login/Login';
import { GraphDashboard } from './screens/GraphDashboard/GraphDashboard';
import { BrowserRouter as Router, Route, Navigate, createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';
import { PrivateRoute}  from "./components/auth/PrivateRoute"
import { SideMenu } from './screens/SideMenu/SideMenu'
import { Users } from './screens/Users/Users'
import { CategoriesActivities } from './screens/CategoriesActivities/CategoriesActivities'
import { Roles } from './screens/Roles/Roles'
import { UserDetailPage } from './screens/Users/UserDetailPage/UserDetailPage'
import { EventDetailPage } from './screens/EventDetailPage/EventDetail'
import './App.css'
import { Events } from './screens/Events/Events';
import { DashboardProfile } from './services/network';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';
import { auth } from './firebaseConfig';
import { Loader } from './components/auth/Loader';
import { Reviews } from './screens/Reviews/Reviews';

function App() {

  const dashboardUser: DashboardProfile | null = useSelector((state: RootState) => state.dashboardUser.dashboardUser)
  const canSeeRoles = useMemo(() => {
    if (!dashboardUser) {
      return false
    }

    if (!dashboardUser.role || !dashboardUser.role.title) {
      return false
    }

    return dashboardUser.role.title === process.env.REACT_APP_ROLE_ADMINISTRATOR
  }, [dashboardUser])

  const canSeeActivities = useMemo(() => {
    if (!dashboardUser) {
      return false
    }

    if (!dashboardUser.role || !dashboardUser.role.title) {
      return false
    }

    return dashboardUser.role.title !== process.env.REACT_APP_ROLE_OFFICE
  }, [dashboardUser])

  const canSeeReviews = useMemo(() => {
    if (!dashboardUser) {
      return false
    }

    if (!dashboardUser.role || !dashboardUser.role.title) {
      return false
    }

    return dashboardUser.role.title === process.env.REACT_APP_ROLE_ADMINISTRATOR || dashboardUser.role.title === process.env.REACT_APP_ROLE_BACKOFFICE
  }, [dashboardUser])

  const [appReady, isAppReady] = useState<boolean>(false)

  useEffect(() => {
    auth.authStateReady()
      .then(() => isAppReady(true))
  }, [])

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Private Routes */}
      <Route element={<PrivateRoute Component={SideMenu} />}>
        <Route path="graph-dashboard" element={<PrivateRoute Component={GraphDashboard} />} />
        <Route path="users" element={<PrivateRoute Component={Users} />} />
        <Route path="events" element={<PrivateRoute Component={Events} />} />
        {canSeeReviews && <Route path="reviews" element={<PrivateRoute Component={Reviews} />} />}
        <Route path="events/:eventid" element={<PrivateRoute Component={EventDetailPage} />} />
        <Route path="users/userinfo/:id" element={<PrivateRoute Component={UserDetailPage} />} />
        <Route path="users/userinfo/:userid/:eventid" element={<PrivateRoute Component={EventDetailPage} />} />
        {canSeeActivities && <Route path="categories-and-activities" element={<PrivateRoute Component={CategoriesActivities} />} />}
        {canSeeRoles && <Route path="roles" element={<PrivateRoute Component={Roles} />} />}
      </Route>
    </>
    )
  );
  return (
    appReady
    ? <RouterProvider router={router} />
    : <Loader />
  )
}

export default App
